import axios from "axios";

import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { useQuery } from "@tanstack/react-query";

const getNonMatchingAttributes = async (tsid, tsrid) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=nonMatchingAttr&teststepid=${tsid}&TSRId=${tsrid}`,
  );

  return response.data;
};

const useGetNonMatchingAttributes = (tsid, tsrid, options) => {
  return useQuery({
    queryKey: ["nonMatchingAttributes", tsid],
    queryFn: () => getNonMatchingAttributes(tsid, tsrid),
    enabled: options.enabled,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options,
  });
};
export default useGetNonMatchingAttributes;
